import { Languages } from '@gimlite/common';
import { DateTime } from 'luxon';
import { v4 as uuidv4 } from 'uuid';
import { AntiPassBackMode } from '../../client/graphql';
import {
  ContractBaseFormType,
  ContractDetailsFormType,
} from '../../form/contract-create/contract-create.form';
import { CredentialType } from '../mapper/credential.mapper';

export const DefaultCredentialsQrcodeWizard = ({
  t,
  lang,
}: {
  t: Function;
  lang: Languages | null;
}): CredentialType.CredentialFromFront => {
  return {
    _id: uuidv4(),
    name: 'QRCODE',
    generatedAt: DateTime.now().toFormat('dd/MM/yyyy HH:mm:ss'),
    value: t('generatedAtTheEnd'),
  };
};

export const DefaultContractBaseWizard = ({
  t,
  lang,
}: {
  t: Function;
  lang: Languages | null;
}): ContractBaseFormType.Data.ContractBase => {
  return {
    startDate: new Date().toISOString(),
    endDate: null,
    APBMode: AntiPassBackMode.None,
    APBNext: false,
    reference: null,
    description: null,
    state: true,
    capacity: null,
    articleCode: null,
  };
};

export const DefaultContractDetailsWizard = ({
  t,
  lang,
}: {
  t: Function;
  lang: Languages | null;
}): ContractDetailsFormType.Data.ContractDetails => {
  return {
    _id: uuidv4(),
    name1: null,
    name2: null,
    address1: null,
    address2: null,
    city: null,
    zipcode: null,
    country: 'CHE',
    username: null,
    lang: lang,
    contractId: null,
    motoristId: null,
    gender: null,
    shortUid: null,
    inviteMotorist: false,
  };
};
